import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=e79e4592"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports